import React, {useState} from "react";
import {useDeskingContext} from "../../contexts/DeskingContext";
import {SkeletonLoader} from "../../components/SkeletonLoader";
import classnames from "classnames";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {useUserContext} from "../../contexts/UserContext";
import {useModalsStore} from "../../stores/modalsStore";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const DeskingTableRowCell = ({dealId, quote, isPurchase, term, lender}) => {
    const { profileState } = useUserContext()
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {
        createDeal,
        createDealResponse,
        updateDeal,
        updateDealResponse,
        deskingState,
        onSave,
        pricing_id,
        selectedTerm,
        setSelectedTerm,
        selectedLender,
        setSelectedLender,
        dealState,
        fetchDeskingResponse,
    } = useDeskingContext()

    const isSelected = Boolean(
        String(selectedTerm) === String(term) &&
        String(lender) === String(selectedLender)
    )

    const closeModalById = useModalsStore((state) => state.closeModalById)

    const getLeadId = () => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('lead_id')) {
            return urlParams.get('lead_id')
        }
    }

    const saveQuote = (quote) => {
        setSelectedTerm(quote.term)
        setSelectedLender(quote.lender_name)

        let updateData = {
            pricing_id: pricing_id,
            ...deskingState,
            term: quote.term,
            lender: quote.lender_name,
        }

        if (dealId) {
            if (dealState) {
                let newDealState = structuredClone(dealState)

                updateData = {
                    pricing_id: pricing_id,
                    ...deskingState,
                    ...newDealState,
                    term: quote.term,
                    lender: quote.lender_name,
                    desired_payment: null,  // when desking many quotes it is impossible to force a payment
                }
            }
            return updateDeal(dealId, updateData).then((data) => {
                const updateData = data?.data
                closeModalById("DeskingModal")
                onSave && onSave(updateData)
            }).catch(() => {})
        } else {
            if (getLeadId()) {
                updateData['leads'] = [getLeadId()]
            }
            const createDealData = {...deskingState, ...updateData, quotes: null}

            return createDeal(createDealData).then((data) => {
                const createData = data?.data
                closeModalById("DeskingModal")
                onSave && onSave(createData)
            }).catch(() => {})
        }
    }

    if (!quote) {
        return <td className={'disabled'}></td>
    }

    const isLoading = (createDealResponse?.loading || updateDealResponse?.loading)
    const isLoadingAndSelected = isLoading && isSelected
    const isCashPurchase = deskingState.is_one_pay && isPurchase
    const isSortByLender = profileState?.desking_sort_by === 'Lender'

    return (
        <SkeletonLoader loading={isLoadingAndSelected}>
            <td
                onClick={() => {
                    if (!isLoading) {
                        saveQuote(quote)
                    }
                }}
                className={'quote'}
            >
                <Stack
                    direction="column"
                    justifyContent="space-between"
                    alignItems="start"
                    className={classnames('info', {
                        selected: isSelected,
                        isPurchase: isPurchase,
                    })}
                >
                    {
                        !isCashPurchase &&
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={'info-payment'}
                        >
                            <Typography fontWeight={700} variant="div">
                                {quote.monthly_payment.toDollarFormat()}
                            </Typography>
                        </Stack>
                    }
                    {
                        isPurchase && !isCashPurchase &&
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className={'info-payment'}
                        >
                            <Typography
                                fontWeight={500}
                                variant="div"
                                sx={{
                                fontSize: '12px',
                            }}>
                                {quote.apr}%
                            </Typography>
                        </Stack>
                    }
                    {
                        isCashPurchase &&
                        <div className={'info-payment'}>
                            <Typography fontWeight={700} variant="div">
                                {quote.monthly_payment.toDollarFormat()}
                            </Typography>
                        </div>
                    }
                    {
                        !isSortByLender &&
                        <Typography
                            fontWeight={700}
                            variant="div"
                            fontSize={10}
                            style={{
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                width: isTabletOrMobile ? "100%" : "100px",
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {quote.lender_name}
                        </Typography>
                    }
                </Stack>

            </td>
        </SkeletonLoader>
    )
}